<template>
  <div v-if="selecionado">
    <div class="row" style="height: 400px;">
        <div class="col s12 m6 pa-0" id="topoPagina" style="height: 100%;">
            <div style="display: flex;align-items: center;justify-content: center; height: 100%;" class="col s12 white z-depth-1 pa-0">
                <img style="height: 100%;width: auto;" class="col s12 responsive-img ma-0 pa-1" :src="selecionado.fotoAlta">
            </div>
        </div>
        <div class="col s12 m6 mb-1">
            <h5>
                <i class="material-icons" v-if="exibirIndicadorMrg"
                :class="definirCorMrgDet(selecionado)">brightness_1</i>
                {{selecionado.itemDescricao}}
            </h5>
            <div class="divider"></div>
            <p class="fonte small w500 deep-orange-text darken-4" v-if="selecionado.itemTextoBloqueio">{{selecionado.itemTextoBloqueio}}</p>
            <table v-if="exibirPreco">
                <thead>
                    <tr colspan="2">Valores/Impostos</tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Pre&ccedil;o Unit&aacute;rio</td>
                        <td class="right-align">{{valoresExibicao.valorTabela | grana}}</td>
                    </tr>
                    <tr>
                        <td :class="priceClass">Desconto
                            <span v-if="valoresExibicao.qtdMin > 1" class="fonte small w300">m&iacute;nimo de {{valoresExibicao.qtdMin}} pe&ccedil;as para desconto</span>
                            <span v-if="valoresExibicao.qtdMax" class="fonte small w300">m&aacute;ximo de {{valoresExibicao.qtdMax}} pe&ccedil;as para desconto</span>
                        </td>
                        <td class="right-align" :class="priceClass">{{valoresExibicao.percDesc}}%</td>
                    </tr>
                    <tr>
                        <td>Valor L&iacute;quido</td>
                        <td class="right-align">{{valoresExibicao.vlComDesc | grana}}</td>
                    </tr>
                    <tr>
                        <td>Substitui&ccedil;&atilde;o Tribut&aacute;ria</td>
                        <td class="right-align">{{valoresExibicao.vlIcmsSt | grana}}</td>
                    </tr>
                    <tr>
                        <td>Valor Final (com impostos):</td>
                        <td class="right-align"><h5 :class="priceClass">{{valoresExibicao.vlTotal | grana}}</h5></td>
                    </tr>
                    <tr v-if="!env.temPerfil(usuario.usuaRole, ['CLIENTE'])">
                        <td class="grey-text text-darken-1">Disponibilidade</td>
                        <td class="grey-text text-darken-1 right-align">{{valoresExibicao.qtdDisponivel}} {{valoresExibicao.unidade}}</td>
                    </tr>
                    <!-- Controle de seleção do produto para o pedido -->
                    <template v-if="habilitarFuncaoAdicionarCarrinho">
                        <tr v-if="!selecionado.itemTextoBloqueio">
                            <td>Quantidade</td>
                            <td class="right-align">
                                <div class="input-field inline ">
                                    <input id="qtd_adicionar" type="number"  @wheel="$event.target.blur()" min="0" class="validate right-align" v-model="quantidadeSelecionada" :step="env && env.pedido_multiplicar_quantidade_digitada_embalagem ? selecionado.itemEmbMult : 1" @change="checkQuantidadeDeposito">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Total a adicionar</td>
                            <td class="right-align"><h5 :class="priceClass" id="sp-total">{{ (selecionado.tempValorTotal * quantidadeSelecionada)  | grana}}</h5></td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <!-- Controle de seleção do produto para o pedido -->

        </div>
        <div v-if="habilitarFuncaoAdicionarCarrinho && !selecionado.itemTextoBloqueio" class="col s12 pa-0">
            <div class="col s12 m8 pa-0 mb-1" v-if="mapItensPedidoAberto == null || mapItensPedidoAberto[`${selecionado.itemId}` || mensagemExtraAdicaoView]">
                <div class="card red lighten-5 red-text center col s12 m11 pa-1 ma-0">
                    <span v-if="!mapItensPedidoAberto">Não há pedido aberto para o cliente selecionado, um novo pedido será criado.</span>
                    <span v-else-if="mapItensPedidoAberto[`${selecionado.itemId}`]">Este produto já foi adicionado ao carrinho</span>
                    <span v-else-if="mensagemExtraAdicaoView">{{mensagemExtraAdicaoView}}</span>
                </div>
            </div>
            <div class="col s12 m4 pa-0 mb-1" v-if="mapItensPedidoAberto == null || !mapItensPedidoAberto[`${selecionado.itemId}`]">
                <a
                    @click.prevent="adicionarCarrinhoPelaVisualizacao(selecionado)"
                    class="col s12 m10 waves-effect waves-light btn-large btn right">
                    <i class="material-icons left">add_shopping_cart</i>
                    Adicionar ao Pedido
                </a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col s12 white z-depth-1" style="padding:15px;">
            <table class="striped">
                <thead>
                    <tr>
                        <th><h5>Informa&ccedil;&otilde;es T&eacute;cnicas</h5></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="row">
                        <div class="col s4"><b>{{dicionario.item_codigo}}: </b></div><div class="col s8">{{selecionado.itemSku}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>{{dicionario.item_ref_externo}}: </b></div><div class="col s8">{{selecionado.itemRefExterno}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>{{dicionario.item_sku_fabricante}}: </b></div><div class="col s8">{{selecionado.itemSkuFabricante}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>{{dicionario.atributo_1}}: </b></div><div class="col s8">{{selecionado.itemAtributo1}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>{{dicionario.atributo_2}}: </b></div><div class="col s8">{{selecionado.itemAtributo2}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>Ncm: </b></div><div class="col s8">{{selecionado.itemNcm}}</div>
                    </tr>
                    <tr class="row" v-if="dimensoesProduto">
                        <div class="col s4"><b>Dimens&otilde;es: </b></div><div class="col s8">{{dimensoesProduto}}</div>
                    </tr>
                    <tr class="row" v-if="pesoProduto">
                        <div class="col s4"><b>Peso: </b></div><div class="col s8">{{pesoProduto}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>C&#243;digo de Barras: </b></div><div class="col s8" v-if="itemInfoComplementar">{{itemInfoComplementar.itemCodbarras}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>C&#243;digo CST: </b></div><div class="col s8">{{selecionado.codcst}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>Pis/Cofins: </b></div>
                        <div class="col s8">
                            <span v-if="selecionado.itemInPis == 'M'">Monof&#225;sico</span>
                            <span v-else-if="selecionado.itemInPis == 'C'">Cumulativo</span>
                            <span v-else>N&atilde;o definido</span>
                        </div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>Garantia: </b></div>
                        <div class="col s8">
                            <span v-if="selecionado.itemTextoGarantia">{{selecionado.itemTextoGarantia}}</span>
                        </div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>Descri&#231;&#227;o Adicional: </b></div><div class="col s8"><span v-html="selecionado.descricaoAdicional"></span></div>
                    </tr>
                    <tr class="row">
                        <div class="col s4">
                            <b>Aplicação: </b>
                            <a
                                v-if="textoAplicacao"
                                @click.prevent="copiarAplicacao"
                                class="btn-floating btn-small waves-effect waves-light tooltipped"
                                data-position="top"
                                data-tooltip="Copiar aplicação">
                                <i class="material-icons">content_copy</i>
                            </a>
                        </div>
                        <div class="col s8"><span v-html="descritivoHtml"></span></div>
                    </tr>
                    <template v-if="env && env.vizualizar_sincronia_fraga_iten_detalhe && itemInfoComplementar">
                        <tr class="row">
                            <div class="col s4"><b>ID Fraga: </b></div>
                            <div class="col s8">
                                <span v-if="itemInfoComplementar.itemIdFraga">{{itemInfoComplementar.itemIdFraga}}</span>
                                <span v-else>N&atilde;o Sincronizado</span>
                            </div>
                        </tr>
                        <tr class="row">
                            <div class="col s4"><b>Ultima Sincronia Fraga: </b></div>
                            <div class="col s8">
                                <span v-if="itemInfoComplementar.itemDthUltSincronizacaoFraga">{{itemInfoComplementar.itemDthUltSincronizacaoFraga | datahora}}</span>
                                <span v-else-if="itemInfoComplementar.itemIdFraga">{{itemInfoComplementar.itemIdFraga}}</span>
                                <span v-else>N&atilde;o Sincronizado</span>
                            </div>
                        </tr>
                    </template>
                    <tr class="row" v-if="env.usar_descricao_adicional_item && selecionado.descricaoAdicional">
                        <div class="col s4"><b>Descri&ccedil;&atilde;o: </b></div><div class="col s8">{{selecionado.descricaoAdicional.replace(/(<([^>]+)>)/ig, "")}}</div>
                    </tr>
                    <tr 
                        class="row" 
                        v-if="
                            selecionado.depiQtdPedCompra 
                            && selecionado.depiQtdPedCompra > 0 
                            && selecionado.previsaoChegada
                            && env.exibir_pedido_compra 
                            && !(usuario.usuaRole === 'CLIENTE')
                        "
                    >
                        <div class="col s4"><b>Previs&atilde;o de chegada: </b></div>
                        <div class="col s8">{{selecionado.previsaoChegada}}</div>
                    </tr>
                    <tr class="row" v-if="itemInfoComplementar">
                        <div class="col s4"><b>Informa&ccedil;&otilde;es Complementares: </b></div>
                        <div class="col s8">{{itemInfoComplementar.itemTextoLivreEcom}}</div>
                    </tr>
                    <tr class="row">
                        <div class="col s4"><b>Link para o v&iacute;deo: </b></div>
                        <div class="col s8" v-if="itemInfoComplementar">
                         <a :href="itemInfoComplementar.itemUrlVideo" target="_blank">{{itemInfoComplementar.itemUrlVideo}}</a>
                        </div>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import StHelper from '../../helpers/StHelper';
import ServiceFactory from '../../services/ServiceFactory';

export default {
  name: 'item-viewer',
  props:{
		exibirPreco: { type: Boolean, default: true },
	selecionado: null,
	dicionario: null,
	usuario: null,
	habilitarFuncaoAdicionarCarrinho:null,
	mapItensPedidoAberto: null,
	quantidadeSelecionada:0,
	trabalhaComListaDeFalta:null,
    ehItemPedido: false,
	mostrarMarkupCliente: {type:Boolean, default:false},
    clienteSelecionado: null,
    env:null,
  },
  data() {
      return {
        itemService: null,
        itemInfoComplementar: null,
      }
  	},
	computed: {
        exibirIndicadorMrg: function () {
			return this.exibirPreco && this.env.roles_autorizados_visualizar_markup_pedido && this.env.roles_autorizados_visualizar_markup_pedido.includes(this.usuario.usuaRole);
		},
		descritivoHtml: function() {
            return StHelper.quebraLinha(this.descritivoProduto);
		},
        descritivoProduto: function() {
            if(!this.selecionado) return '';

            return this.selecionado.itemEspecificacoes ||
                this.selecionado.item_especificacoes ||
                (this.itemInfoComplementar && (this.itemInfoComplementar.itemEspecificacoes || this.itemInfoComplementar.item_especificacoes)) ||
                this.selecionado.itemDescritivo ||
                this.selecionado.item_descritivo;
        },
        textoAplicacao: function() {
            if(!this.descritivoProduto) return '';
            return `${this.descritivoProduto}`
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/(<([^>]+)>)/ig, '')
                .trim();
        },
		priceClass: function() {
			if (this.selecionado.depiQtdDisponivel == 0 ) return 'red-text texto-riscado';
    		else if (this.selecionado.prdtPercDesc > 0) return 'indigo-text darken-4';
    		else return '';
		},
        dimensoesProduto: function() {
            if(!this.selecionado) return '';

            let altura = this.obtemDimensao(['itemAlturaCm', 'item_altura_cm']);
            let largura = this.obtemDimensao(['itemLarguraCm', 'item_largura_cm']);
            let comprimento = this.obtemDimensao(['itemComprimentoCm', 'item_comprimento_cm', 'itemProfundidadeCm', 'item_profundidade_cm']);

            if(!altura && !largura && !comprimento) return '';

            return [
                altura ? `Altura: ${altura} cm` : null,
                largura ? `Largura: ${largura} cm` : null,
                comprimento ? `Comprimento: ${comprimento} cm` : null,
            ].filter(Boolean).join(' | ');
        },
        pesoProduto: function() {
            if(!this.selecionado) return '';

            let peso = this.obtemDimensao(['itemPeso', 'item_peso']);
            if(!peso) return '';

            return `${peso} kg`;
        },
        valoresExibicao: function () {
            if(this.ehItemPedido) {
                return {
                    valorTabela: this.calculaMarkup(this.selecionado.peddPrUnit),
                    qtdMin: this.selecionado.prdtQtdMin,
                    qtdMax: this.selecionado.prdtQtdMax,
                    percDesc: this.selecionado.peddPercDesc,
                    vlComDesc: this.calculaMarkup(this.selecionado.peddVlUnitLiq),
                    vlIcmsSt: this.selecionado.peddVlIcmsSt,
                    vlTotal: this.calculaMarkup(this.selecionado.peddVlFinal),
                    qtdDisponivel: this.selecionado.depiQtdDisponivel,
                    unidade: this.selecionado.itemUnidade
                };
            } else {
                return {
                    valorTabela: this.calculaMarkup(this.selecionado.tabdValor),
                    qtdMin: this.selecionado.prdtQtdMin,
                    qtdMax: this.selecionado.prdtQtdMax,
                    percDesc: this.selecionado.prdtPercDesc?this.selecionado.prdtPercDesc:0,
                    vlComDesc: this.calculaMarkup(this.selecionado.prdtVlComDesc?this.selecionado.prdtVlComDesc:this.selecionado.tabdValor),
                    vlIcmsSt: this.selecionado.tempValorIcmsSt?this.selecionado.tempValorIcmsSt:0,
                    vlTotal: this.calculaMarkup(this.selecionado.tempValorTotal),
                    qtdDisponivel: this.selecionado.depiQtdDisponivel,
                    unidade: this.selecionado.itemUnidade
                };
            }
        },
	},
	watch: {
		quantidadeSelecionada: function(newValue) {
			this.novoTotal = this.selecionado.tempValorTotal * newValue;
		},
		buscaSimples: function(newValue) {
			window.localStorage.setItem('BUSCA_SIMPLIFICADA',newValue?'S':'N');
		},
        selecionado: function(newValue) {
            newValue && this.getItemInfoComplementar(newValue);
		}
	},
    mounted(){
        this.selecionado && this.getItemInfoComplementar(this.selecionado);
    },
	created () {
		let factory = new ServiceFactory(this.$http);
		factory.item().then(serv=> this.itemService = serv);
	},
	methods: {
        definirCorMrgDet(item) {
			let percMarkup = StHelper.calcularMrgItem(item.itemSku, item.tabdValor, item.quantidadeSelecionada, item.tabdPrecoCusto);
			const percMarkupFloat = parseFloat(percMarkup);
			const percVermelhoFloat = parseFloat(this.env.percentual_indicador_vermelho_markup_pedido);
			const percLaranjaFloat = parseFloat(this.env.percentual_indicador_laranja_markup_pedido);
			if (percMarkupFloat < percVermelhoFloat) {
				return "red-text";
			} else if (
				percMarkupFloat >= percVermelhoFloat &&
				percMarkupFloat <= percLaranjaFloat
			) {
				return "yellow-text";
			} else {
				return "green-text";
			}
		},
		checkQuantidadeDeposito() {
			if (this.env && this.env.pedido_multiplicar_quantidade_digitada_embalagem
				&& this.quantidadeSelecionada % this.selecionado.itemEmbMult != 0 )  {
					this.quantidadeSelecionada = Math.ceil(this.quantidadeSelecionada / this.selecionado.itemEmbMult)*this.selecionado.itemEmbMult;
			}

			if(this.trabalhaComListaDeFalta
				&& this.quantidadeSelecionada > this.selecionado.depiQtdDisponivel 
				&& this.selecionado.depiQtdDisponivel > 0
				) {
				//let quantidadeFalta = this.quantidadeSelecionada - this.selecionado.depiQtdDisponivel;
				let quantidadeFalta = Math.ceil( (this.quantidadeSelecionada - this.selecionado.depiQtdDisponivel) / this.selecionado.itemEmbMult) * this.selecionado.itemEmbMult;
				this.mensagemExtraAdicaoView = `	A quantidade disponível desse produto é de ${this.selecionado.depiQtdDisponivel},
					portanto a quantidade de ${quantidadeFalta} será adicionada na FALTA DE MERCADORIA.`
			}
		},
		adicionarCarrinhoPelaVisualizacao(item) {
            if(this.quantidadeSelecionada) {
                item.quantidadeSelecionada = this.quantidadeSelecionada;
            } else {
                item.quantidadeSelecionada = 0;
            }
			this.$emit('adicionarCarrinhoPelaVisualizacao', item);
		},
        calculaMarkup(preco) {
            const { habilitar_calculo_markup_cliente } = this.env;
			const perfilCliente = this.usuario.usuaRole.toUpperCase().includes('CLIENTE');

			if(this.mostrarMarkupCliente && perfilCliente && habilitar_calculo_markup_cliente) {
				return preco * (1 + this.clienteSelecionado.clieMarkup / 100);
			}
			return preco;
		},
        obtemDimensao(campos) {
            let valor = campos
                .map(campo => this.selecionado[campo])
                .find(v => v !== null && v !== undefined && v !== '');

            if(valor === null || valor === undefined || valor === '') return '';
            return `${valor}`.replace('.', ',');
        },
        copiarAplicacao() {
            if(!this.textoAplicacao) return;

            if(navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(this.textoAplicacao)
                    .then(() => Materialize.toast('Aplicação copiada para a área de transferência', 3000))
                    .catch(() => this.copiarAplicacaoFallback());
            } else {
                this.copiarAplicacaoFallback();
            }
        },
        copiarAplicacaoFallback() {
            let input = document.createElement('textarea');
            input.value = this.textoAplicacao;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            Materialize.toast('Aplicação copiada para a área de transferência', 3000);
        },
        getItemInfoComplementar(item) {
            const itemId = this.obtemItemIdValido(item);
            if(!itemId) {
                this.itemInfoComplementar = null;
                return;
            }
			this.$http.get(`item/${itemId}`)
                .then(response=> response.json())
				.then(item => this.itemInfoComplementar = item)
				.catch(err => console.log('error: ', err))
		},
        obtemItemIdValido(item) {
            const itemId = item && typeof item === 'object' ? (item.itemId || item.id) : item;
            if(itemId === null || itemId === undefined || itemId === '' || itemId === 'null' || itemId === 'undefined') return null;
            return /^\d+$/.test(`${itemId}`) ? itemId : null;
        },
	}
}

</script>



// WEBPACK FOOTER //
// ItemViewer.vue?1f9bf7a6